import { Article, useCheckoutContext } from '@zooplus/checkout-state';

import ItemPrice from '../item-price/item-price';
import { ItemPriceCartV2, ItemPriceCartV1 } from '../new-item-price';

import { CART_VERSION, CHECKOUT_STATE_PROJECT_ID, PRICE_TYPE } from '@utilities/constants';

const PriceWrapper = ({ article }: { article: Article }) => {
  const { cartVersion, mainTogglesMap = {} } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const isCartApiV2 = cartVersion === CART_VERSION.V2;
  const isNewPricingEnabled = mainTogglesMap.NEW_PRICING_COMPONENT_IN_CART_AND_PREVIEW;

  const displayBeforePrices = isCartApiV2 ? !!article.referencePrice : article.displayBeforePrices;

  return isNewPricingEnabled ? (
    isCartApiV2 ? (
      <ItemPriceCartV2 article={article} />
    ) : (
      <ItemPriceCartV1 article={article} />
    )
  ) : article.bestPriceArticle ? (
    <ItemPrice priceType={PRICE_TYPE.BEST_PRICE} article={article} />
  ) : !displayBeforePrices ? (
    <ItemPrice priceType={PRICE_TYPE.STANDARD_PRICE} article={article} />
  ) : (
    <ItemPrice priceType={PRICE_TYPE.REDUCED_PRICE} article={article} />
  );
};

export default PriceWrapper;
